import { useState, useEffect } from 'react'

export default function LoadingScreen({ loadingInfo }) {
    const [loadingDots, setLoadingDots] = useState('')

    useEffect(() => {
        const interval = setInterval(() => {
            setLoadingDots(prev => {
                if (prev.length >= 3) return ''
                return prev + '.'
            })
        }, 500)
        return () => clearInterval(interval)
    }, [])

    useEffect(() => {
        if (loadingInfo.assetsLoaded) {
            setTimeout(() => {
                const loadingScreen = document.querySelector('.loading-screen')
                loadingScreen.classList.add('completed')
                setTimeout(() => {
                    // remove loading screen
                    loadingScreen.remove()
                }, 1000)
            }, 600)
        }
    }, [loadingInfo.assetsLoaded])

    return (
        <div className="loading-screen">
            <div className="loading-content hidden">
                <div className="loading-header">Loading</div>
                <div className="loading-bar-container">
                    <div
                        className="loading-bar"
                        style={{ width: `${loadingInfo.progress}%` }}
                    ></div>
                </div>
                <p>{loadingInfo.text}{loadingDots} ({loadingInfo.progress}%)</p>
            </div>
        </div>
    )
} 